// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KUSX","col":"styles_col__kk8eM"};